import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import enums from 'scoreboard/components/enums'
import calendars from 'scoreboard/components/calendars'
import {
	shortenedAndUnshortened
} from 'scoreboard/components/format-value'
import template from './scorecard-structure-results.hbs'
import scorecardItemTemplate from './scorecard-structure-item.hbs'
import scorecardItemFieldTemplate from './scorecard-structure-item-field.hbs'
import invalidFilters from '../common/invalid-filters.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import ResultsView from '../common/results-view'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import nonAbbreviatedValuesTooltip from './non-abbreviated-values-tooltip.hbs'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import DataType from 'scoreboard/datasets/model/data-type'
const { PERCENT } = DataType

var ScorecardStructureResults = ResultsView.extend({

	className: 'scroll-layout-xy table-hack-row display-pane-body form',

	events: {
		'click tbody a': 'overview',
		'touchend tbody a': 'overview'
	},

	render: function() {
		this.columns = _.keyBy(this.model.get('columns').columns)
		this.$el.html(template(this.context()))

		var renderTree = function(results) {
			var tree = results[0]
			//handle no results found (node deleted)
			if (_.isEmpty(tree)) {
				this.$el.html(new EmptyState({ body: invalidFilters() }).render().remove('header').el)
				// We already have a display header on this page, so no  need to
				this.$el.find('header').remove()
				// Make sure empty display styling kicks in
				$('.display-layout').addClass('has-empty-display')
			} else {
				//to be compatible with streaming, we add the root node as the
				//first element in the resulting list
				this.$('tbody').append(this._buildTable(tree))
			}
		}.bind(this)

		var tree = this.model.initialData
		if (tree) {
			renderTree(tree)
		} else {
			this.model.fetch().then(function (res) {
				renderTree(res.results)
			})
		}

		this._updateHeaderVisibility()
		this.errorFieldTooltip = new TooltipAndDetails({
			el: this.el,
			selector: '[data-unshortened-value]',
			tooltipContent: e => {
				return nonAbbreviatedValuesTooltip({
					header: e.target.dataset.unshortenedHeader,
					value: e.target.dataset.unshortenedValue
				})
			},
			tooltipOptions: {
				extraClass: 'tooltip-and-details non-abbreviated-tooltip'
			}
		})

		return this
	},

	_gatherStructure: function(obj, depth) {
		this.meta.ids.push(obj.positionId)
		this.meta.nodes[obj.positionId] = { leaves: 0, depth: depth, item: obj }
		if (obj.children && obj.children.length) {
			this.meta.maxDepth = Math.max(this.meta.maxDepth, ++depth)
			_.each(obj.children, function(child) {
				if (this._gatherStructure(child, depth)) {
					this.meta.nodes[obj.positionId].leaves++
				} else {
					this.meta.nodes[obj.positionId].leaves += this.meta.nodes[child.positionId].leaves
				}
			}.bind(this))
			return false	//node is not a leaf
		} else {
			return true		//node is a leaf
		}
	},

	_buildTable: function(tree) {
		this.meta = { ids:[], nodes: {}, maxDepth: 1 }
		this._gatherStructure(tree, 1)
		var html = ''
		var newRow = true;

		//the number of <tr> = number of leaves in the tree
		_.each(this.meta.ids, function(id) {
			var node = this.meta.nodes[id]
			if (newRow) {
				html += '<tr>'
				newRow = false
			}
			html += this._addObject(node)
			if (!node.leaves) {	//nodes with no children, signal end of row
				html += '</tr>'
				newRow = true
			}
		}.bind(this))
		return html
	},

	_addObject: function(node) {
		var obj = node.item
		let abbValues = this.model.get('showAbbreviatedValues')

		// add the group type label for owner or updater groups
		this._extendPrincipalLabels(obj.owners)
		this._extendPrincipalLabels(obj.updaters)

		var html = scorecardItemFieldTemplate({
			titleCode: enums.scorecardItemType[obj.type],
			label: _.escape(obj.label)
		})

		var { shortened, unshortened } = shortenedAndUnshortened({
			value: obj.weight || 0,
			dataType: PERCENT
		})
		var fields = {
			'description': {titleCode: 'common.description', label: escapePreserveLineBreaks(obj.description)},
			'owners': {titleCode: 'common.owners', label: _.escape(_.map(obj.owners, 'label').join(', '))},
			'updaters': {titleCode: 'common.updaters', label: _.escape(_.map(obj.updaters, 'label').join(', ')), ignore: obj.type != 'metric'},
			'calendar-id': {
				titleCode: 'report.customReport.nativeCalendar',
				label: obj.calendarId ? _.escape(calendars.calendarsById[obj.calendarId].label) : '',
				ignore: obj.type != 'metric'
			},
			'weight': {
				titleCode: 'scorecards.node.weight',
				label: _.escape(abbValues ? shortened : unshortened),
				unshortenedValue: shortened == unshortened || !abbValues ? null : unshortened
			}
		}
		_.each(['description', 'owners', 'updaters', 'calendar-id', 'weight'], function(col) {
			if (!this.columns[col] || fields[col].ignore === true) { return }
			html += scorecardItemFieldTemplate(fields[col])
		}.bind(this))

		if (this.columns['thresholds']) {
			_.each(obj.thresholds, threshold => {
				var { shortened, unshortened } = shortenedAndUnshortened(_.defaults({
					value: threshold.value
				}, obj))
				html += scorecardItemFieldTemplate({
					titleCode: threshold.label,
					label: _.escape(this.model.get('showAbbreviatedValues') ? shortened : unshortened),
					unshortenedValue: shortened == unshortened || !abbValues ? null : unshortened
				})
			})
		}

		// If there are rowspans present in the table, mark it with .has-rowspans. This
		// class is used in order to render the table properly when exported (generic-export.scss)
		if (node.leaves > 1) {
			this.$('.scorecard-structure-panel, .scorecard-structure-results').addClass('has-rowspans')
		}

		return scorecardItemTemplate({
			//rowspan is the number of leaves underneath the node, for leaf nodes its 1
			rowspan: Math.max(node.leaves, 1),
			//colspan is the max depth - leaf's level in the tree, non-leaf nodes its 1
			colspan: !node.leaves ? this.meta.maxDepth + 1 - node.depth : 1,
			html: html
		})
	},

	_extendPrincipalLabels: function (principals) {
		_.each(principals, (principal) => {
			let groupTypeLabel = principal.groupType ? '  (' + groupType.label(principal.groupType) + ')' : ''
			principal.label = principal.label + groupTypeLabel
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.errorFieldTooltip], 'remove')
	}

})

export default ScorecardStructureResults
export { template }

ScorecardStructureResults.__filename__ = 'reports/scorecard-structure/scorecard-structure-results.js'
